var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4025 3.12951C28.0683 1.90577 27.0888 0.941125 25.8466 0.611602C23.5772 -4.25651e-08 14.4997 0 14.4997 0C14.4997 0 5.42247 0 3.15312 0.588437C1.9348 0.917604 0.9314 1.90599 0.59722 3.12951C0 5.36463 0 10 0 10C0 10 0 14.6588 0.59722 16.8705C0.931718 18.0941 1.91092 19.0587 3.1533 19.3882C5.44635 20 14.5 20 14.5 20C14.5 20 23.5772 20 25.8466 19.4116C27.089 19.0822 28.0683 18.1176 28.4028 16.894C28.9999 14.6587 28.9999 10.0235 28.9999 10.0235C28.9999 10.0235 29.0238 5.36458 28.4025 3.12951ZM11.6095 14.2823V5.71763L19.158 9.99996L11.6095 14.2823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e73a949016eea0175fe62f15f174969d.svg";
export { ForwardRef as ReactComponent };